import React, { Component } from 'react';
import { Button } from '@trevor/ui-components';
import { SELECT } from '../../util/enums/EnumLayers';
import AjaxSpinner from '../AjaxSpinner';
import flex from '../../css/module/flex.css';

class ModalSelect extends Component {
  static modalType() {
    return SELECT;
  }

  static reducer(modals) {
    return modals.selectModal;
  }

  static title() {
    return <span>Click the headers to show/hide columns</span>;
  }

  buildColumn(key, column, isVisible, usedAliases, userInteraction, columns) {
    const props = {
      section: 'toggleColumn',
      columnName: column.name(),
      columns,
    };
    const tdClassName = `user-clickable fixed-width-cell ${
      isVisible ? '' : 'preview-data'
    }`;
    const tableNameClassName = `hidden-data-table-header ${
      isVisible ? 'faint' : ''
    }`;
    if (!usedAliases[column.name().alias()]) {
      // TODO
    }
    const tovName = column.name().alias()
      ? usedAliases[column.name().alias()].name()
      : '';
    return (
      <td
        key={key}
        className={tdClassName}
        onClick={userInteraction(props)}
        style={{ padding: '0px' }}
      >
        <div
          className="w-100 overflow-auto"
          style={{ paddingLeft: '15px', paddingRight: '25px' }}
        >
          <span className={tableNameClassName}>{tovName}</span>
          <br />
          <b className="data-table-header">{column.name().name()}</b>
        </div>
      </td>
    );
  }

  render() {
    const { state, columns, userInteraction, usedAliases } = this.props;

    const headers = [<td key="empty" className="no-border" />];
    const columnNames = [];

    // invisible columns
    const invisibleColumns = {};
    columns.forEach((c) => {
      const isVisible = state.visible.findIndex((s) => s.equals(c.name())) > -1;
      headers.push(
        this.buildColumn(
          headers.length,
          c,
          isVisible,
          usedAliases,
          userInteraction,
          columns,
        ),
      );
      columnNames.push(c.name());
      invisibleColumns[c.name().toString()] = !isVisible;
    });

    const data = [];

    if (state.results) {
      const colIndexByColName = {};
      for (let i = state.results.headings().length - 1; i >= 0; i--) {
        const cn = state.results.headings()[i].columnName().toString();
        colIndexByColName[cn] = i;
      }
      state.results
        .rows()
        .filter((row, i) => i < 6)
        .forEach((row, index) => {
          const cells = columnNames.map((cn) => {
            const colIndex = colIndexByColName[cn.toString()];
            const tdClassName = `dt-cell fixed-width-cell${
              invisibleColumns[cn.toString()] ? ' preview-data' : ''
            }`;
            const cell = row.cells()[colIndex];
            return (
              <td key={colIndex} className={tdClassName}>
                {cell.html()}
              </td>
            );
          });
          data.push(
            <tr key={index}>
              <td className="no-border" />
              {cells}
            </tr>,
          );
        });
    }

    return (
      <div className="h-100" style={{ overflow: 'auto' }}>
        <div
          className={`w-100 ${flex.alignItemsCenter} ${flex.justifyContentCenter}`}
          style={{
            position: 'sticky',
            left: '0px',
            top: '0px',
            background: '#fff',
            zIndex: 2,
            paddingBottom: '5px',
          }}
        >
          <Button
            variant="secondary"
            className={` margin-right-10`}
            disabled={state.visible.length === columns.length}
            onClick={userInteraction({
              section: 'selectAll',
              columns,
            })}
          >
            Show all
          </Button>
          <Button
            variant="secondary"
            className="margin-right-10"
            disabled={state.visible.length === 0}
            onClick={userInteraction({ section: 'selectNone' })}
          >
            Hide all
          </Button>
        </div>
        <div
          className="btn-table-container position-relative"
          style={{ overflow: 'visible' }}
        >
          {!state.results ? (
            <div
              style={{
                position: 'absolute',
                top: '80px',
                left: '0',
                height: 'calc(100% - 80px)',
              }}
              className={`h-100 w-100 ${flex.alignItemsCenter} ${flex.justifyContentCenter}`}
            >
              <AjaxSpinner small />
            </div>
          ) : null}
          <table className="data-table">
            <tbody>
              <tr className="thead">
                {headers}
                <td className="no-border" />
              </tr>
              {data}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default ModalSelect;
